import { type GridColDef } from "@mui/x-data-grid";

import { PublicTechnicalDecisionTableItem } from "api/public/technicalDecisions/technicalDecisions.types";
import BulletListCell from "components/MUI/DataGrid/Cells/BulletList.cell";
import LinkCell from "components/MUI/DataGrid/Cells/Link.cell";
import { dataGridDateGetter } from "components/MUI/DataGrid/DataGrid.utils";

const formatProtectionProfiles = (
  unformattedProfiles: PublicTechnicalDecisionTableItem,
) => {
  if (!unformattedProfiles) return [];

  const { protection_profile = [], sunset_protection_profile = [] } =
    unformattedProfiles;
  const allProfiles = [...protection_profile, ...sunset_protection_profile];
  allProfiles.sort(
    (a, b) => a.pp_short_name?.localeCompare(b.pp_short_name ?? "") ?? 0,
  );

  return allProfiles;
};

export const techDecisionsColumns: GridColDef<PublicTechnicalDecisionTableItem>[] =
  [
    {
      headerName: "Item",
      field: "identifier",
      renderCell: ({ row }) => (
        <LinkCell
          to={`/technical-decisions/${row.identifier}`}
          label={row.identifier}
        />
      ),
      flex: 1,
    },
    {
      headerName: "Title",
      field: "title",
      flex: 1,
    },
    {
      headerName: "Protection Profiles",
      field: "protection_profile",
      valueGetter: (value, row) => {
        const allProfiles = formatProtectionProfiles(row);

        const profileItems = allProfiles
          .map((pp) => pp.pp_short_name)
          .join(",");
        return profileItems;
      },
      renderCell: ({ row }) => {
        const allProfiles = formatProtectionProfiles(row);
        const profileItems = allProfiles.map((pp) => ({
          item: pp.pp_short_name || "",
          id: pp.pp_id,
        }));

        return <BulletListCell items={profileItems} />;
      },
      flex: 1,
    },
    { headerName: "References", field: "related_to", flex: 1 },
    {
      headerName: "Publication Date",
      field: "publication_date",
      valueGetter: dataGridDateGetter,
      type: "date",
      flex: 1,
    },
    {
      headerName: "Archived Date",
      field: "removed_on",
      valueGetter: dataGridDateGetter,
      type: "date",
      flex: 1,
    },
  ];
